import { useEffect, useState } from "react";
import Lenis from "lenis";
import { siteSettings as settings } from "../data/siteData";
import { menuItems } from "../data/menuData";
import { galleryImages } from "../data/galleryData";
import { events } from "../data/eventsData";
import { Navbar } from "../components/site/Navbar";
import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { About } from "../components/site/About";
import { MenuSection } from "../components/site/MenuSection";
import { BookingSection } from "../components/site/BookingSection";
import { GallerySection } from "../components/site/GallerySection";
import { EventsSection } from "../components/site/EventsSection";
import { LocationSection } from "../components/site/LocationSection";
import { ContactsSection } from "../components/site/ContactsSection";
import { Footer } from "../components/site/Footer";
import { MobileDock } from "../components/site/MobileDock";

export default function HomePage() {
  const [prefill, setPrefill] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
  }, []);

  const hasEvents = events.filter((e) => e.active).length > 0;

  return (
    <div id="top" className="grain bg-obsidian min-h-screen">
      <Navbar hasEvents={hasEvents} />
      <main>
        <Hero settings={settings} />
        <Marquee />
        <About settings={settings} />
        <MenuSection items={menuItems.filter((i) => i.available)} settings={settings} />
        <BookingSection settings={settings} prefill={prefill} />
        <GallerySection images={galleryImages} />
        <EventsSection events={events.filter((e) => e.active)} onBook={setPrefill} />
        <LocationSection settings={settings} />
        <ContactsSection settings={settings} />
      </main>
      <Footer settings={settings} hasEvents={hasEvents} />
      <MobileDock settings={settings} />
    </div>
  );
}
